import { useEffect, useRef, useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// Direct Google OAuth (own branded consent screen) — verifies the ID token on our backend
export const GoogleSignInButton = ({ onAuthenticated, memberType = 'addict', testId = 'google-signin-button' }) => {
  const containerRef = useRef(null);
  const [btnWidth, setBtnWidth] = useState(320);

  useEffect(() => {
    const measure = () => {
      if (containerRef.current?.offsetWidth) {
        setBtnWidth(Math.max(220, Math.min(320, containerRef.current.offsetWidth)));
      }
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  const handleSuccess = async (credentialResponse) => {
    try {
      const res = await axios.post(`${BACKEND_URL}/api/auth/google/verify`, {
        credential: credentialResponse.credential,
        member_type: memberType
      });
      if (res.data.success) {
        onAuthenticated(res.data);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Google sign-in failed. Please try again.');
    }
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div ref={containerRef} data-testid={testId} style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={() => toast.error('Google sign-in failed. Please try again.')}
          theme="outline"
          size="large"
          shape="pill"
          text="continue_with"
          width={String(btnWidth)}
        />
      </div>
    </GoogleOAuthProvider>
  );
};

export const OrDivider = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', margin: '1rem 0' }}>
    <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
    <span style={{ fontSize: '0.75rem', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em' }}>or</span>
    <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
  </div>
);
